import { gql } from '@/utilities/gql';

export const NARRATIVE_EDIT_BUTTON_FRAGMENT = gql(`
  fragment NarrativeEditButtonFields on Narrative @_unmask {
    id
    owner {
      publicId
    }
    companyId
    latestPublishedUpdate {
      id
      willLockAt
    }
    earliestPublishedUpdate {
      id
    }
  }
`);

export const NARRATIVE_CARD_ACTIONS_FRAGMENT = gql(
  `
  fragment NarrativeCardActionsFields on Narrative @_unmask {
    id
    isPrimary
    valuation {
      type
    }
    company {
      id
    }
    ...NarrativeEditButtonFields
  }
`,
  [NARRATIVE_EDIT_BUTTON_FRAGMENT]
);

export const NARRATIVE_URL_COMPANY_FRAGMENT = gql(`
  fragment NarrativeUrlCompanyFields on Company @_unmask {
    canonicalURL
  }
`);

export const NARRATIVE_OWNER_FRAGMENT = gql(`
  fragment NarrativeOwnerFields on CommunityProfile @_unmask {
    publicId
    displayName
    imageUrl
    role
    disclaimerType
  }
`);

// =========

export const NARRATIVE_CARD_SYNTHETIC_FRAGMENT = gql(
  `
  fragment NarrativeCardSyntheticFields on Narrative @_unmask {
    id
    title
    type
    slug
    primaryCount
    valuation {
      type
      fairValue
      intrinsicDiscount
    }
    company {
      id
      tickerSymbol
      name
      canonicalURL
      data {
        currencyInfo
      }
      info {
        url
      }
      analysisValue {
        priceTargetAnalystCount
      }
    }
    ...NarrativeCardActionsFields
  }
`,
  [NARRATIVE_CARD_ACTIONS_FRAGMENT]
);

export const NARRATIVE_CARD_FRAGMENT = gql(
  `
  fragment NarrativeCardFields on Narrative @_unmask {
    id
    slug
    updatedAt
    primaryCount
    commentCount
    title
    isPublic
    excerpt
    type
    isSponsored
    lastFeaturedAt
    company {
      id
      tickerSymbol
      name
      data {
        currencyInfo
      }
      analysisValue {
        priceTargetAnalystCount
      }
      info {
        url
        hasLogo
      }
      ...NarrativeUrlCompanyFields
    }
    owner {
      ...NarrativeOwnerFields
    }
    valuation {
      fairValue
      intrinsicDiscount
      revenuePercentageChange
    }
    voteCount {
      upvotes
    }
    draftUpdate {
      title
      coreExcerpt
      valuation {
        fairValue
        revenuePercentageChange
        intrinsicDiscount
      }
      updatedAt
    }
    earliestPublishedUpdate {
      willLockAt
    }
    latestPublishedUpdate {
      willLockAt
      coreExcerpt
      title
    }
    ...NarrativeCardActionsFields
  }
`,
  [
    NARRATIVE_URL_COMPANY_FRAGMENT,
    NARRATIVE_OWNER_FRAGMENT,
    NARRATIVE_CARD_ACTIONS_FRAGMENT,
  ]
);

export const NARRATIVE_CARD_ISOMORPHIC_FRAGMENT = gql(
  `
  fragment NarrativeCardIsomorphicFields on Narrative @_unmask {
    ...NarrativeCardFields
    ...NarrativeCardSyntheticFields
  }
`,
  [NARRATIVE_CARD_FRAGMENT, NARRATIVE_CARD_SYNTHETIC_FRAGMENT]
);

export const FAIR_VALUE_HISTOGRAM_COMPANY_FRAGMENT = gql(`
  fragment FairValueHistogramCompanyFields on Company @_unmask {
    tickerSymbol
    data {
      currencyInfo
    }
    myValuation {
      fairValue
    }
    analysisValue {
      lastSharePrice
    }
    valuationHistogram {
      primaryCount
      min
      max
      buckets {
        min
        max
        primaryCount
      }
    }
  }
`);

export const COMPANY_REPORT_NARRATIVE_CARD_FRAGMENT = gql(
  `
  fragment CompanyReportNarrativeCardFields on Narrative @_unmask {
    id
    company {
      id
      uniqueSymbol
    }
    ...NarrativeCardIsomorphicFields
  }
`,
  [NARRATIVE_CARD_ISOMORPHIC_FRAGMENT]
);
